import React from "react";
import AppContainer from "../../../components/AppContainer";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationAdmissionRequest.json";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const headerData = [
  "ID",
  "Request at",
  "Student Detail",
  "Source",
  "Class",
  "Admission Fee",
  "Payment Type",
  "Status",
  "Action",
];

const displayRows = [
  "_id",
  "date_time",
  "ed_student_detail",
  "source",
  "ed_student_class",
  "ed_student_fee",
  "ed_fess_payment_type",
  "ed_fess_request_status",
  "actions",
];

const AdmissionRequest = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleClickOnstatusMenu = (row, type) => {
    if (type === "View Details") {
      dispatch(
        setActiveTab({
          ...activeTab,
          education_admission: "ed_admission_request_details",
        })
      );
    }
  };
  return (
    <AppContainer
      primaryHeading={"Admission request"}
      secondaryHeading={"Add details are required please enter carefully"}
    >
      <DynamicTable
        minWidth={1200}
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showStatusMenu={true}
        handleClickOnstatusMenu={handleClickOnstatusMenu}
      />
    </AppContainer>
  );
};

export default AdmissionRequest;
